module.exports = __webpack_public_path__ + "static/media/icona_frecce.359e4a23.svg";